import AppComponent from './AppComponent';


export default AppComponent;
